import { z } from 'my-zod'
import { addOnModel } from './add-on-model'

export const addOnDraft = addOnModel
  .pick({
    id: true,
    type: true
  })
  .augment({
    addOnProductId: z.string().uuid(),
    addOnProductVersionId: z.number()
  })

export type addOnDraft = z.infer<typeof addOnDraft>
